<template>

    <div class="typing">
    
        <span></span>
    
        <span></span>
    
        <span></span>
    
    </div>
    
    </template>
    
    <style scoped>
    
    .typing{
    
        display:flex;
    
        gap:8px;
    
        margin-left:60px;
    
    }
    
    span{
    
        width:10px;
    
        height:10px;
    
        border-radius:50%;
    
        background:#991b1b;
    
        animation:bounce 1.4s infinite;
    
    }
    
    span:nth-child(2){
    
        animation-delay:.2s;
    
    }
    
    span:nth-child(3){
    
        animation-delay:.4s;
    
    }
    
    @keyframes bounce{
    
        0%{
    
            transform:translateY(0);
    
            opacity:.3;
    
        }
    
        50%{
    
            transform:translateY(-6px);
    
            opacity:1;
    
        }
    
        100%{
    
            transform:translateY(0);
    
            opacity:.3;
    
        }
    
    }
    
    </style>